export const locale = {
  my_messages: 'My Messages',
};
